import { FlowConnector, FlowSource, FlowTarget } from './components';
import * as Network from '../../redux/actions/network.actions';
import * as UIAction from '../../redux/actions/ui.actions';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import LoadingDial from '../loading/LoadingDial';
const InlineConnection = (props) => {
  const {
    tenant,
    filterFlow,
    filterEntity,
    localization,
    helperText,
    hideFlows = false,
    multipleSources = undefined,
    multipleConnectors = undefined,
    hideBackButtons = false,
    nextStep = '',
    connectionName = null,
    shouldDisable = undefined,
    operation = null,
  } = props;
  const supportedFlows = useSelector((state) => state.flows.supportedFlows);
  const linkedFlows = useSelector((state) => state.flows.linkedFlows);
  const dispatch = useDispatch();
  const hasJwtToken = useSelector((state) => state.configuration.jwtToken);
  const byLabel = useCallback(([k1, v1], [k2, v2]) => {
    if (v1.name < v2.name) return -1;
    if (v1.name > v2.name) return 1;
    return 0;
  }, []);

  useEffect(() => {
    dispatch(UIAction.setHideFlows(hideFlows));
    if (multipleSources !== undefined) UIAction.setMultipleSources(multipleSources);
    if (multipleConnectors !== undefined) UIAction.setMultipleConnectors(multipleConnectors);
    UIAction.setHideBackButtons(hideBackButtons);
    UIAction.setNextStep(nextStep);
    UIAction.setLocalization(localization);
    UIAction.setShouldDisable(shouldDisable);
    UIAction.setHelperText(helperText);
    UIAction.setOperation(operation);
  }, []);

  useEffect(() => {
    dispatch(UIAction.setTenant(tenant));
    UIAction.setIsConnection(true);
  }, [tenant]);

  useEffect(() => {
    if (!linkedFlows) {
      dispatch(Network.fetchLinkedFlows(tenant));
    }
  }, [linkedFlows, hasJwtToken]);

  useEffect(() => {
    if (!supportedFlows) {
      dispatch(Network.fetchSupportedFlows());
    }
  }, [supportedFlows, hasJwtToken]);

  const handleFilterFlow = useCallback(
    ([id, flow]) => {
      if (typeof filterFlow === 'function') return filterFlow(id);
      return true;
    },
    [filterFlow],
  );

  if (!linkedFlows || !supportedFlows)
    return (
      <Box className="hg-flows-container" display="flex" flexDirection="column" width="100%">
        <CircularProgress />
      </Box>
    );

  return (
    <Box className="hg-flows-container" display="flex" flexDirection="column" width="100%" gap={3}>
      {linkedFlows &&
        Object.entries(linkedFlows)
          .filter(handleFilterFlow)
          .sort(byLabel)
          .map(([id, flow]) => {
            return flow.type ? (
              <FlowTarget key={id} filterEntity={filterEntity} operation={operation} {...flow} />
            ) : flow?.version === 2 ? (
              <FlowConnector
                key={flow.id}
                multipleConnectors={multipleConnectors}
                filterEntity={filterEntity}
                connectionName={connectionName}
                operation={operation}
                {...flow}
              />
            ) : (
              <FlowSource
                key={flow.id}
                multipleSources={multipleSources}
                filterEntity={filterEntity}
                connectionName={connectionName}
                operation={operation}
                {...flow}
              />
            );
          })}
      {supportedFlows &&
        Object.entries(supportedFlows)
          .filter(([id, flow]) => linkedFlows && !linkedFlows[id])
          .filter(handleFilterFlow)
          .sort(byLabel)
          .map(([id, flow]) => {
            return flow.type ? (
              <FlowTarget key={id} filterEntity={filterEntity} operation={operation} {...flow} />
            ) : flow?.version === 2 ? (
              <FlowConnector
                key={flow.id}
                multipleConnectors={multipleConnectors}
                filterEntity={filterEntity}
                connectionName={connectionName}
                operation={operation}
                {...flow}
              />
            ) : (
              <FlowSource
                key={flow.id}
                multipleSources={multipleSources}
                filterEntity={filterEntity}
                connectionName={connectionName}
                operation={operation}
                {...flow}
              />
            );
          })}
    </Box>
  );
};

export default InlineConnection;
